import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FaBook, FaCog, FaBars, FaTimes, FaPen,FaSearch, FaUser } from 'react-icons/fa'; // Import the book, plus, bars, and times icons
import TableView from './TableView'; // Ensure TableView is correctly imported
import ReportIncidentForm from './ReportIncidentForm';
import Autosuggest from 'react-autosuggest';
import { useIsMobile } from './hooks/isMobile';
import useIsLaptop  from './hooks/isLaptop';
import { fetchWithAuth } from './lib/utils';
import Modal from "react-modal"; 
import Cookies from 'js-cookie';
import AsyncSelect from "react-select/async";
import { Box, Paper, Button, Typography } from '@mui/material';
import {jwtDecode} from "jwt-decode";
import {Snackbar, Tooltip} from '@mui/material';

Modal.setAppElement("#root"); // or whatever your root div is

const HomePage = () => {
    const navigate = useNavigate();
    const [view, setView] = useState('map'); // State to manage the current view
    const [query, setQuery] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const isMobile = useIsMobile(); // Use the useIsMobile hook
    const [isNavOpen, setIsNavOpen] = useState(false); // State to manage the mobile nav menu
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [username, setUsername] = useState('');
    const modalRef = useRef(null);
    const isLaptop = useIsLaptop();
    
    useEffect(() => {
        if (submitSuccess) {
            const timer = setTimeout(() => {
                setSubmitSuccess(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [submitSuccess]);
  
    useEffect(() => {
        const token = Cookies.get("accessToken");
        const username = Cookies.get("username");
        if (token) {
            try {
                const decodedToken = jwtDecode(token);
                const expirationTime = decodedToken.exp * 1000; // Convert to milliseconds
                const currentTime = Date.now();
                const timeUntilExpiration = expirationTime - currentTime;

                if (timeUntilExpiration > 0) {
                    // Redirect to auth page when token expires
                    setTimeout(() => {
                        Cookies.remove("accessToken");
                        navigate("/auth");
                    }, timeUntilExpiration);
                    setIsLoggedIn(true);
                    setUsername(username);
                } else {
                    navigate("/auth");
                }
            } catch (error) {
                console.error("Invalid token:", error);
                Cookies.remove("accessToken");
                navigate("/auth");
            }
        }
    }, [navigate]);
    
     const loadOptions = async (inputValue, callback) => {
        if (!inputValue.trim()) {
            callback([]);
            return;
        }

        try {
            const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/incidents/typeAhead?query=${inputValue}`);
            const data = await response.json();

            if (Array.isArray(data)) {
                callback(
                    data.slice(0, 5).map((item) => ({
                        value: item.id,
                        label: `${item.organization} - ${item.city}, ${item.state}, ${item.country}`
                    }))
                );
            } else {
                callback([]);
            }
        } catch (error) {
            console.error("Error fetching suggestions:", error);
            callback([]);
        }
    };

    const handleSelectChange = (selectedOption) => {
        if (selectedOption && selectedOption.value) {
            navigate(`/incidentdetail/${selectedOption.value}`);
        }
    };
    const handleChange = (event, { newValue }) => {
        setQuery(newValue || ''); // Ensure it's always a string
    };
    const handleLogout = async () => {
                try {
                    const refreshToken = Cookies.get("refreshToken");
        
                    const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/logout`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ refreshToken }),
                    });
        
                    if (response.ok) {
                        Cookies.remove("accessToken");
                        Cookies.remove("refreshToken");
                        setIsLoggedIn(false);
                        setUsername('');
                        navigate("/auth");
                    } else {
                        navigate("/auth");
                    }
                } catch (err) {
                    console.error("Logout error:", err);
                }
            };
     const checkAuthAndRedirect = (callback) => {
            const token = Cookies.get("accessToken");
            if (!token) {
                navigate("/auth"); // Redirect to auth if no token
            } else {
                callback(); // Execute the button's original action
            }
        };
    
        const checkAuthAndNavigate = (path) => {
            const token = Cookies.get("accessToken");
            if (!token) {
                navigate("/auth"); // Redirect to auth if no token
            } else {
                navigate(path); // Navigate to the intended path
            }
        };

   

    return (
        <div className="bg-gray-100 min-h-screen">
           
           <nav className={`bg-white shadow-md ${isMobile? 'p-4' : 'p-4'}`}>
                    <div className="container mx-auto justify-between flex items-center">
                    <Link to="/home" className="text-xl font-bold text-green-800 flex items-center">
                        SafeSpace
                        <img 
                            src="https://my-image-bucket-the-green-book.s3.us-east-1.amazonaws.com/logos/Frame+1.png"
                            alt="SafeSpace Logo" 
                            className="h-6 w-auto mr-2" 
                        />
                        </Link>
                        
                        <div className="items-center">
                        {!isMobile && (
                           <div className="flex-grow max-w-4xl relative">
                           <div className="absolute left-05 top-05 transform -translate-y-1/2 text-gray-500 z-10">
                               <FaSearch size={18} />
                           </div>
                       
                           <AsyncSelect
                               loadOptions={loadOptions}
                               placeholder="Search incidents..."
                               onChange={handleSelectChange}
                               styles={{
                                   control: (provided) => ({
                                       ...provided,
                                       paddingLeft: "30px",
                                       minWidth: "300px",  // Prevents shrinking too much
                                       width: "100%",      // Ensures it takes up full space
                                       maxWidth: "600px",  // Prevents it from getting too large
                                       minHeight: "40px",
                                       borderRadius: "8px",
                                   }),
                               }}
                           />
                       </div>
                        )}
                            {isMobile && (
                                
                                <button
                                    className="ml-4 text-green-800"
                                    onClick={() => setIsNavOpen(!isNavOpen)}
                                >
                                    {isNavOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
                                </button>
                            )}
                        </div>
                        <ul className={`flex space-x-4 ${isMobile ? 'hidden' : 'block'} md:flex`}>
                        <li>
                            <button 
                                onClick={() => checkAuthAndNavigate("/")} 
                                className="text-gray-700 hover:text-blue-600"
                            >
                                Home
                            </button>
                        </li>
                        <li>
                            <button 
                                onClick={() => checkAuthAndNavigate("/about")} 
                                className="text-gray-700 hover:text-blue-600"
                            >
                                About
                            </button>
                        </li>
                        <li>
                            <button 
                                onClick={() => checkAuthAndNavigate("/incidents")} 
                                className="text-gray-700 hover:text-blue-600"
                            >
                                Incidents
                            </button>
                        </li>
                        <li>
                        <Tooltip title="View your account" arrow>
                            <Link to={`/profile`} className="text-gray-700 hover:text-blue-600">
                                <FaCog size={24} />
                            </Link>
                            </Tooltip>
                        </li>
                        </ul>
                    </div>
                    {isNavOpen && (
                        <ul className="flex flex-col space-y-4">
                             <li>
                            <button 
                                onClick={() => checkAuthAndNavigate("/")} 
                                className="text-gray-700 hover:text-blue-600"
                            >
                                Home
                            </button>
                        </li>
                        <li>
                            <button 
                                onClick={() => checkAuthAndNavigate("/about")} 
                                className="text-gray-700 hover:text-blue-600"
                            >
                                About
                            </button>
                        </li>
                        <li>
                            <button 
                                onClick={() => checkAuthAndNavigate("/incidents")} 
                                className="text-gray-700 hover:text-blue-600"
                            >
                                Incidents
                            </button>
                        </li>
                        <li>
                        <Tooltip title="View your account" arrow>
                            <Link to={`/profile`} className="text-gray-700 hover:text-blue-600">
                                <FaCog size={24} />
                            </Link>
                            </Tooltip>
                        </li>
                        </ul>
                    )}
                </nav>
                
           
            <div className={`flex flex-col items-center ${isMobile ? 'px-4 py-2 mt-4' : isLaptop ? 'mt-2' : 'mt-4'} relative`}>
                {/* <h2 className={`${isMobile ? 'md:hidden' : 'text-2xl font-bold text-gray-800 mb-4'}`}>Report an Incident</h2> */}
                <div className="flex justify-between w-full max-w-6xl">
                <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: "space-between",
                    backgroundColor: "#F4F4F4",
                    borderRadius: "8px",
                    alignItems: 'center',
                    mt: isMobile ? 2 : 8,
                    px: isMobile ? 0 : 0,
                }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                        maxWidth: '600px',
                        p: 0,
                        borderRadius: 2,
                        boxShadow: 3,
                    }}
                >
                    <Button
                        fullWidth
                        variant={view === 'map' ? 'contained' : 'text'}
                        sx={{
                            textTransform: 'none',
                            minWidth: '85px',
                            backgroundColor: view === 'map' ? '#276749' : 'transparent',
                            color: view === 'map' ? '#FFF' : '#276749',
                            fontWeight: view === 'map' ? 'bold' : 'normal',
                            borderRadius: 2,
                        }}
                        onClick={() =>  checkAuthAndRedirect(() =>setView('map'))}
                    >
                        Map
                    </Button>
                    <Button
                        fullWidth
                        variant={view === 'table' ? 'contained' : 'text'}
                        sx={{
                            minWidth: '85px',
                            textTransform: 'none',
                            backgroundColor: view === 'table' ? '#276749' : '#transparent',
                            color: view === 'table' ? '#FFF' : '#276749',
                            fontWeight: view === 'table' ? 'bold' : 'normal',
                            borderRadius: 2,
                        }}
                        onClick={() => checkAuthAndRedirect(() => setView('table'))}
                    >
                        List
                    </Button>
                </Paper>
                </Box>
                <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: "space-between",
                    backgroundColor: "#F4F4F4",
                    borderRadius: "8px",
                    alignItems: 'center',
                    mt: isMobile ? 2 : 8,
                    px: isMobile ? 0 : 110,
                }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                        maxWidth: '600px',
                        p: 0,
                        mt: 0,
                        borderRadius: 2,
                        boxShadow: 3,
                        
                    }}
                >
                   
                    <Button
                        fullWidth
                        variant="contained"
                        sx={{
                            textTransform: 'none',
                            minWidth: '85px',
                            backgroundColor: '#276749',
                            color: '#fff',
                            fontWeight: 'bold',
                            borderRadius: 2,
                        }}
                        onClick={() => checkAuthAndRedirect(() => setModalIsOpen(true))}
                    >
                        <FaPen style={{ marginRight: '8px' }} /> Report
                    </Button>
                    
                </Paper>
                </Box>
                    <Modal
                        isOpen={modalIsOpen}
                        onRequestClose={() => setModalIsOpen(false)}
                        style={{
                            overlay: {
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                width: isMobile ? "0%" : "0%",
                                height: isMobile ? "0%" : "0%",
                            },
                            content: {
                                position: "fixed",
                                top: "50%",
                                left: "50%",
                                width: "50%",
                                height: "50%",
                                transform: "translate(-50%, -50%)",
                                background: "white",
                                padding: "20px 10px",
                                borderRadius: "12px",
                                boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
                                width: isMobile ? "100%" : "600px",
                                maxWidth: "600px",
                                overflow: "auto",
                                minHeight: isMobile ? "60vh" : isLaptop ? "80vh" : "60vh",
                                maxHeight: isMobile ? "80vh" : isLaptop ? "80vh" : "80vh",                                
                                display: "flex",  // ✅ Enable flexbox
                                flexDirection: "column", // ✅ Stack elements vertically
                                justifyContent: "center", // ✅ Center vertically
                                alignItems: "center", // ✅ Center horizontally
                                textAlign: "center", // ✅ Align text in center (optional)
                            },
                        }}
                    >
                        {/* ✅ Move the close button to the top-right */}
                        <button
                            onClick={() => checkAuthAndRedirect(() =>setModalIsOpen(false))}
                            style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                            }}
                        >
                            <FaTimes size={24} color="gray" />
                        </button>
                        
                        <ReportIncidentForm 
                            setModalIsOpen={setModalIsOpen} 
                            onIncidentSubmit={() => {
                                console.log('Submitting')
                                setSubmitSuccess(true); // Show success message first
                                setTimeout(() => {
                                setModalIsOpen(false); // Close modal after delay
                                }, 3000); // second delay
                            }} 
                            dialogRef={modalRef} 
                        />
                        <button 
                            className="mt-4 px-4 py-2 bg-red-600 text-white" 
                            onClick={() => {
                                setModalIsOpen(false); 
                            }}
                            >
                            Close
                    </button>
                    </Modal>
                </div>
            </div>


           {/* Conditionally Render Components */}
           <div className="mt-4 flex justify-center items-center w-full">
                {view === 'map' && (
                    <iframe 
                        src="/map.html" 
                        title="Map" 
                        className={`border-1 w-full ${isMobile ? 'h-screen' : isLaptop ?'max-w-6xl h-500' :'max-w-6xl h-600'}`} // Adjust height and width based on mobile or desktop
                        allow="fullscreen"
                        allowFullScreen

                    ></iframe>
                )}
                {view === 'table' && (
                    <div className={`border-0  ${isMobile ? 'h-screen w-screen overflow-scroll' : 'max-w-6xl h-500 w-full'}`}>
                        <TableView />
                    </div>
                )}
            </div>
        </div>
    );
};

export default HomePage;